// extracted by mini-css-extract-plugin
export default {"tablewrapper":"Table_tablewrapper__yxGj3","id":"Table_id__ya49b","btnItems":"Table_btnItems__wK3PT","btnSVG":"Table_btnSVG__fBwfL"};